import styled from 'styled-components';

import { BLACK, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const CELL_SIZE = 480;

export const Item = styled.div`
  display: flex;
  color: ${WHITE};
  background-color: ${BLACK};
  min-height: ${CELL_SIZE}px;
  margin-bottom: 1em;

  > h2 {
    margin: 0 0 20px;
    font-size: 26px;
    line-height: 1.1em;
    letter-spacing: 1px;
    max-width: 354px;

    > span {
      text-transform: uppercase;
    }

    ${media.tabletL`
      font-size: 38px;
    `};
  }

  > p {
    font-size: 14px;
    line-height: 1.5em;
    letter-spacing: 0.5px;
    flex: 1;
    max-width: 354px;
    margin: 0;

    > span {
      font-weight: 400;
    }

    ${media.tabletL`
      font-size: 16px;
      line-height: 1.1em;
    `};
  }

  ${media.tabletL`
    grid-column: 1 / span 2;
  `};
`;

export const SeminarTitle = styled.h4`
  font-weight: 400;
  font-size: 26px;
  text-transform: uppercase;
  margin: 0 0 1em;
  color: ${WHITE};

  ${media.tabletL`
    font-size: 29px;
    margin: 0;
  `};
`;

export const SeminarLeft = styled.div`
  flex: none;
  margin-right: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;

  ${media.tabletL`
    flex: 1;
  `};
`;

export const SeminarRight = styled.div`
  flex: 3;
  color: #ccc;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;

  > div > p {
    margin-top: 0;
    font-size: 14px;

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;

export const Link = styled.a`
  display: flex;
  flex-direction: column;
  padding: 3em 1em;
  flex: 1;

  ${media.tabletL`
    flex-direction: row;
    padding: 3em;
  `};
`;

export const BottomText = styled.div`
  justify-self: flex-end;
  display: flex;
`;

export const Keys = styled.div`
  flex: 1;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;

export const Values = styled.div`
  flex: 3;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 45%;
  display: none;

  ${media.tabletL`
    display: flex;
    align-items: flex-end;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarsList/Seminar.style.js